(ns frontend.view.dashboard.oppos-per-status.view
  (:require [common.localization :as loc]
            [reagent.core :as r :include-macros true]
            [frontend.bootstrap.components :as rbs]
            [ui.components.card.view :as card]))

(defn status-widget [data place param]
  (let [class (->> place
                   name
                   (str "oppos-per-status-widget--")
                   (str "oppos-per-status-widget "))
        label (->> param
                   name
                   (str "oppos-per-status-")
                   keyword
                   loc/tr)
        num (-> data
                :oppos-per-status
                (get param))]
    [:div {:class class}
     [:div.oppos-per-status-widget__param-holder
      [:div.oppos-per-status-widget__param label]]
     [:div.oppos-per-status-widget__num num]]))

(defn component [data]
  [:div
   [card/card
    [card/header (loc/tr :number-of-oppos-per-status)]
    [card/body
     [:div.grid.grid-cols-10.gap-4
      [:div
       {:class "col-span-5"}
       [status-widget data :top-left :oppo.status/ok]]      ; TODO not sure that this is the best approach with marking widgets as :top-left and so on, it should be done somehow automatically
      [:div
       {:class "col-span-5"}
       [status-widget data :top-right :oppo.status/on-hold]]]
     [:div.grid.grid-cols-10.gap-4
      [:div
       {:class "col-span-5"}
       [status-widget data :bottom-left :oppo.status/passed]]
      [:div
       {:class "col-span-5"}
       [status-widget data :bottom-right :total]]]]]])
